import { isObject } from './is-object';
export function isLocationData(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return 'target' in obj && 'detail' in obj;
}